import { ChangeDetectionStrategy, Component, ElementRef, Inject, Input, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { MemberNotificationService } from 'src/app/shareModule/services/member-notification.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { MemberRegionSelectModalComponent } from '../../../common/common-member-region-select-modal/member-region-select-modal.component';
import { REGION_CATEGORY_IMAGE_LIST } from 'src/app/customers/marketplace/marketplace.model';

import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { BehaviorSubject, filter } from 'rxjs';
import { Store } from '@ngrx/store';
import { loadUser } from 'src/app/shareModule/states/user-details';

import { isPlatformBrowser } from '@angular/common';
import { AppState } from 'src/app/shareModule/states/app.state';
import { loadIndividualProducts } from 'src/app/shareModule/states/individual-all-product';
import { Location } from '@angular/common';
import { GoogleAnalyticsService } from 'src/app/shareModule/services/google-analytics.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: [
    './sign-in.component.scss',
    './otp-input/otp-input.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignInComponent implements OnInit {
  @ViewChild('signinPopup', { static: true }) signinPopup: ElementRef<any>;
  @ViewChild('CheckMemberRegion', { static: true })
  CheckMemberRegion: MemberRegionSelectModalComponent;
  @Input() withoutSteps: boolean = false;
  public modalOpen: Boolean = false;

  currentCard = 1;
  totalCards = 3;
  intervalId: any;
  eyePassword: boolean = false;
  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.local.clearTimeout(this.timeout1)
  }

  startCardLoop(): void {
    this.intervalId = setInterval(() => {
      this.nextCard();
    }, 1000);
  }
  stopCardLoop(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
  nextCard(): void {
    this.currentCard = (this.currentCard % this.totalCards) + 1;
  }

  loginPopup: boolean = false;
  step: number = 1;
  carouselOptions: any = {
    pagination: false,
    slidesPerView: 1,
    spaceBetween: 10,
    allowTouchMove: false,
    loop: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
  };
  public numberArray = [];

  reset = false;

  public selectedPostalCode: string = '';
  public selectedMemberRegion: string = '';
  public selectedMemberPassword: string = '';
  public subregionList: Array<any> = []
  public filteredSubregionList: Array<any> = [];
  public regionList = REGION_CATEGORY_IMAGE_LIST;
  public baseUrl: string = '../../../../../assets/images/shop/';
  public maskedPhoneNumber = '';
  public phoneNumber = '';
  public phoneNumberPin = '';
  public userData: any = null;
  public tokenData: any = null;
  public skipSignInProcessForAll: boolean = false;
  public password: string = '';
  public passwordConfirm: string = '';
  public hasPassword: boolean = false;

  public loginStage: string = ''; //remove
  public passcode: string = '';
  // public passcodeConfirm: string = '';
  public PDPAPolicyCheckbox: boolean = false;
  public otpText: string = null;
  public region: string = '';
  public newUser: boolean = false;
  public isLoading: boolean = false;
  public invalidPasscode: string = '';
  public referralLinkCode: string = '';

  constructor(
    public auth: AuthServiceService,
    private router: Router,
    private local: LocalServiceService,
    private toastr: ToastrService,
    private memberNotificationService: MemberNotificationService,
    public roleService: RoleService,
    public sharedService: SharedService,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    public commonService: CommonService,
    private location: Location,
    private store: Store<AppState>,
    private gaService: GoogleAnalyticsService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject("WINDOW") private window: any,

  ) { }

  ngOnInit(): void {
    if (this.sharedService.isBrowser()) {
      this.route.queryParams.subscribe((params) => {
        if (params['code']) {
          this.referralLinkCode = params['code'];
        }
      });
      this.loginStage = '';

      this.checkIfTestingModeIsEnable();


      this.commonService.subRegionObserver.pipe(filter((i) => !!i)).subscribe((list: any[]) => {
        this.subregionList = list.map((i: any) => {
          try {
            i['postalCode'] = JSON.parse(i['postalCode']) || [];
          } catch (e) {
            i['postalCode'] = [];
          }
          return i;
        });
        this.filteredSubregionList = structuredClone(this.subregionList);
      });
    }
  }

  tutorials() {
    localStorage.setItem('tutorials', JSON.stringify(true));
    this.sharedService.shepherd('new-user');
    this.modalService.dismissAll();
  }
  GoToMySettings() {
    this.sharedService.triggerSelectMyTab(4);
  }
  public removeExistingLoginData(): void {
    try {
      this.local.removeData();
      this.local.removeAdminData();
    } catch (e: any) { }
  }

  // Old Login method
  public signUp(): void {
    const formData = new FormData();
    formData.append('phoneNumber', this.phoneNumber);
    if (this.referralLinkCode) {
      formData.append('referralCode', this.referralLinkCode);
    }
    if (!this.phoneNumber) {
      this.toastr.error('Please Fill Phone Number');
      return;
    }

    if (this.loginStage == '') {
      if (!this.phoneNumberPin) {
        this.toastr.error('Please Enter Pin');
        return;
      }
    }
    this.removeExistingLoginData();
    this.invalidPasscode = '';
    this.isLoading = true;
    this.auth.login_signup_new_customer_marketplace(formData).subscribe(
      (response: any) => {
        // this.tokenData = response.body;
        // this.store.dispatch(loadUser({ id: response.body.id }));
        // this.store.dispatch(
        //   loadFilteredCommunityProducts({
        //     categoryId: '',
        //     subRegionId: response.body.region,
        //     search: '',
        //   })
        // );
        this.verifyLoginData(response.body);
        this.tempToken = response.body.token;
      },
      (e) => {
        this.isLoading = false;
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
        this.loginStage = '';
      }
    );
  }
  // Old Login method

  timeout1: any;
  private _onBoardUserSuccessfully() {
    this.local.saveLoginUserData(this.tokenData);
    this.local.clearTimeout(this.timeout1)
    this.timeout1 = setTimeout(() => {
      this.memberNotificationService.getNotification();
    }, 2000)
    this.gaService.logEvent('login', {
      phone: this.phoneNumber,
      method: 'Phone',
    });
  }

  public tempToken: string = '';
  public verifyLoginData(userData): void {

    //console.log("userData", userData)
    this.isLoading = false;
    this.setUserTheme(userData?.theme || '');
    const user = userData;

    if (user.isBlocked) {
      this.toastr.error(
        'Your account has being blocked, please contact admin for help.'
      );
      return;
    }

    if (!this.skipSignInProcessForAll) {
      this.maskedPhoneNumber = userData?.phoneNumber
        ? userData?.phoneNumber.toString().replace(/\d(?=\d{4})/g, '*')
        : '';
      this.phoneNumber = userData?.phoneNumber;
      this.userData = userData || null;
      if (
        (!this.userData?.isVerified &&
          !this.userData?.passcode &&
          !this.userData?.region &&
          !this.userData?.postalCode) ||
        this.phoneNumber?.toString() == '91318317'
      ) {
        this.loginStage = 'PDPA';
        this.newUser = true;
      } else if (this.loginStage == 'signUp' && !this.userData?.passcode) {
        this.passcode = '';
        this.loginStage = 'SET_NEW_PASSCODE';
      } else if (
        (!this.referralLinkCode && !this.userData?.region) ||
        this.phoneNumber?.toString() == '91318317'
      ) {
        this.loginStage = 'PROFILE_UPDATE_SUB_REGION';
      } else if (
        (!this.referralLinkCode && !this.userData?.postalCode) ||
        this.phoneNumber?.toString() == '91318317'
      ) {
        this.loginStage = 'PROFILE_UPDATE_SUB_REGION';
      } else if (
        !this.userData?.isVerified ||
        this.phoneNumber?.toString() == '91318317'
      ) {
        this.loginStage = 'VERIFY_OTP';
        this.handleSendOTP();
      } else {
        this.loginStage = 'SUCCESSFULLY_LOGIN';

        this.modalRef.close();
        this._onBoardUserSuccessfully();
        this.selectedMemberPassword =
          this.phoneNumber =
          this.loginStage =
          this.maskedPhoneNumber =
          '';
        this.toastr.success('You are successfully logged in');
        this.local.periodicallyCheckLoginUserData();
        //this.redirect();
      }
    } else {
      this.modalService.dismissAll();
      this._onBoardUserSuccessfully();
    }
  }

  public handlePDPACheck(): void {
    if (this.PDPAPolicyCheckbox) {
      this.loginStage = 'VERIFY_OTP';
      this.handleSendOTP();
    } else {
      this.toastr.warning('Please Accept PDPA Policy First!');
    }
  }

  public verifyOTP(otpText = null): void {
    if (otpText != null) {
      this.otpText = otpText;
    }

    if (this.otpText == null) {
      this.toastr.error('Please Fill OTP');
      return;
    }

    this.auth
      .member_verify_otp({
        phone: this.phoneNumber,
        otp: this.otpText,
      }).subscribe((resp: any) => {
        const result = resp.body;
        if (result.success) {
          this.toastr.success(result.message);
          this.tokenData = resp.body;
          this.store.dispatch(loadUser({ id: resp.body.id }));
          if (
            !this.userData?.passcode ||
            this.phoneNumber?.toString() == '91318317'
          ) {
            this.loginStage = 'SET_NEW_PASSCODE';
          } else {
            this.modalService.dismissAll();
          }
        } else {
          this.toastr.error(result.message);
        }
      },
        (e) => {
          this.toastr.error('Internal Server Error');
        }
      );
  }

  public savePasscode() {
    // Validation

    if (!this.passcode) {
      return this.toastr.error('Please Fill Passcode');
    }

    // if (this.passcode != this.passcodeConfirm) {
    //   return this.toastr.error("Passcode Confirmation Doesn't Match");
    // }
    // Validation

    this.auth
      .updateProfileCharacterDetails({
        userId: this.tokenData?.id,
        passcode: this.passcode,
        token: this.tempToken,
      })
      .subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.redirect();
        this.loginStage = 'PROFILE_UPDATE_SUB_REGION';
        this.store.dispatch(loadUser({}));
      });
  }

  // public prev(): void {
  //   if (this.loginStage == 'PROFILE_UPDATE_POSTAL_CODE') {
  //     this.loginStage = 'PROFILE_UPDATE_SUB_REGION';
  //   } else if (this.loginStage == 'PROFILE_UPDATE_SUB_REGION') {
  //     this.loginStage = 'PROFILE_UPDATE_REGION';
  //   }
  // }

  public shopLogout() {
    if (this.sharedService.isBrowser()) {
      this.local.removeData();
      this.local.removeAdminData();
      localStorage.removeItem('passcode');
      //this.local.fetchUser();
      this.passcode =
        this.selectedMemberPassword =
        this.phoneNumber =
        this.loginStage =
        this.maskedPhoneNumber =
        '';
      this.reset = !this.reset;
      this.tokenData = null;
      this.invalidPasscode = '';
      this.otpText = null;
    }
  }

  public setPostalCode(value) {
    this.selectedPostalCode = value;
  }

  public saveProfile(): void {
    let payload = {};
    if (this.selectedMemberRegion) {
      payload['region'] = this.selectedMemberRegion;
    }
    if (this.selectedPostalCode) {
      if (this.selectedPostalCode.length != 6) {
        this.toastr.error("Postal code should be 6 digits");
        return;
      }

      payload['postalCode'] = this.selectedPostalCode;
      payload['isSignUp'] = true;
    }
    payload['userId'] = this.tokenData?.id;
    payload['token'] = this.tempToken;

    this.auth
      .updateProfileCharacterDetails(payload)
      .subscribe((resp: ApiResponse) => {
        this.store.dispatch(loadUser({}));
        this.toastr.success(resp.message);
        this.redirect();
        if (this.newUser) {
          this.skip()
          // if (this.withoutSteps) {
          //   this.skip()
          // } else {
          //   this.loginStage = 'PROFILE_UPDATE_SUCCESSFULLY';
          // }
          this._onBoardUserSuccessfully();
        } else {
          this.selectedMemberPassword =
            this.phoneNumber =
            this.loginStage =
            this.maskedPhoneNumber =
            '';
          this.modalService.dismissAll();
          this._onBoardUserSuccessfully();
        }
      });
  }

  public regionSplit(name: string): string {
    return name && name.includes('|') ? name.split('|')[1] : '';
  }

  public onRegionClick(selected: string) {
    this.region = selected;
    this.loginStage = 'PROFILE_UPDATE_SUB_REGION';
  }

  public onSubRegionClick(selected?: any) {
    if (this.selectedPostalCode.length == 6) {
      if (this.filteredSubregionList.length > 0) {
        this.selectedMemberRegion = this.filteredSubregionList[0].subRegionId;
        this.saveProfile();
      } else {
        // this.toastr.warning("Sub Region not found!")
      }
    } else {
      this.toastr.warning("Please fill PostalCode")
    }
  }

  public checkIfTestingModeIsEnable() {
    this.auth.signInTestMode({}).subscribe((response: any) => {
      this.skipSignInProcessForAll = response.message?.enable;
    });
  }

  public resetPasscode() {
    this.invalidPasscode = this.passcode = '';
    this.loginStage = 'RESET_PASSCODE';
  }

  public handleCloseLoginPopup(): void {
    if (this.maskedPhoneNumber) {
      this.shopLogout();
    }
    // this.stopCardLoop()
    this.modalService.dismissAll();
  }

  delaySendOTP: number = 0;
  handleSendOTP() {
    this.otpText = '';
    if (this.delaySendOTP < 1)
      this.auth
        .member_send_otp({
          phone: this.phoneNumber,
        })
        .subscribe(
          (resp: any) => {
            const result = resp.body;
            if (result.success) {
              this.toastr.success(resp.message);
            } else {
              this.toastr.error(resp.message);
            }
            this.delaySendOTP = 61;
            let interval = setInterval(() => {
              this.delaySendOTP -= 1;
              if (this.delaySendOTP == 0) {
                clearInterval(interval);
              }
            }, 1000);
          },
          (e) => {
            this.toastr.error('Internal Server Error');
          }
        );
  }

  public handleVerify() {
    // Validation
    if (this.passcode == '') {
      return this.toastr.error('Please Fill Passcode');
    }

    // if (this.passcode != this.passcodeConfirm) {
    //   return this.toastr.error("Passcode Confirmation Doesn't Match");
    // }

    if (this.otpText == '') {
      return this.toastr.error('Please Fill OTP');
    }
    // Validation

    this.auth
      .member_reset_passcode({
        password: this.passcode,
        otp: this.otpText,
        phone: this.phoneNumber,
      })
      .subscribe(
        (resp: any) => {
          if (resp.body.success) {
            this.toastr.success(resp.message);
            if (this.loginStage == 'FORGET_PASSCODE') {
              this.loginStage = '';
            } else {
              this.modalService.dismissAll();
              this._onBoardUserSuccessfully();
            }
          } else {
            this.toastr.error(resp.message);
          }
        },
        (e) => {
          this.toastr.error('Internal Server Error');
        }
      );
  }

  public numericOnly(event): boolean {
    if (event.key === 'Enter' && this.loginStage == '') {
      this.logIn();
      return false;
    }

    // Check for max length of 8
    const target = event.target as HTMLInputElement;
    if (target && target.value && target.value.length >= 8 && event.type !== 'paste') {
      return false;
    }

    let result = false;
    const clipboardData = event.clipboardData || (this.window as any).clipboardData;
    const pastedText = clipboardData?.getData('text') || '';

    if (pastedText) {
      // For paste events, check if numeric and enforce max length
      result = /^\d+$/.test(pastedText);
      if (result && target) {
        const currentValue = target.value || '';
        const newValue = currentValue + pastedText;
        if (newValue.length > 8) {
          // Truncate to 8 characters
          target.value = newValue.substring(0, 8);
          return false;
        }
      }
    } else {
      result = /^([0-9])$/.test(event.key);
    }
    return result;
  }

  public forgetPin() {
    this.loginStage = 'FORGET_PASSCODE';
    this.otpText = this.passcode = '';
  }

  public redirect() {
    // let fullUrl = this.location.path();
    // !this.referralLinkCode && !this.router.url.includes('news') && !this.router.url.includes('share') && !fullUrl.includes('product=') && !fullUrl.includes('/product/')
    //   ? this.router.navigateByUrl('/me/nearby')
    //   : '';
  }

  private modalRef: NgbModalRef;
  public openSignInPopup(): void {
    this.startCardLoop();
    if (!this.modalOpen) {
      this.modalOpen = true;
      this.modalRef = this.modalService.open(this.signinPopup, {
        windowClass: 'my_signin_pop',
        // backdrop: 'static',
        keyboard: false,
        size: 'xs',
      });
      this.modalRef.result.then(
        (result) => {
          this.stopCardLoop()
          this.modalOpen = false;
        },
        (reason) => {
          this.stopCardLoop()
          this.modalOpen = false;
        }
      );
    }
  }

  public disableScroll(event: WheelEvent): void {
    event.preventDefault(); // Prevents scrolling behavior
  }

  public setUserTheme(theme): void {
    if (theme && isPlatformBrowser(this.platformId)) {
      this.commonService.setTheme(theme);
    }
  }

  public logIn(): void {
    this.loginStage = '';

    // ***** validation *****
    if (!this.phoneNumber) {
      this.toastr.error('Please Fill Phone Number');
      return;
    }
    if (!this.phoneNumberPin) {
      this.toastr.error('Please Enter Pin');
      return;
    }
    // ***** validation *****

    const formData = new FormData();
    formData.append('phoneNumber', this.phoneNumber);
    formData.append('password', this.phoneNumberPin);

    this.removeExistingLoginData();
    this.invalidPasscode = '';
    this.isLoading = true;
    this.customerService.login(formData).subscribe(
      (response: any) => {
        this.tokenData = response.body;
        if (response?.body?.region) {
          this.store.dispatch(loadIndividualProducts({ categoryId: "", subRegionId: response?.body?.region, search: '' }));
        }
        this.verifyLoginData(response.body);
      },
      (e) => {
        this.isLoading = false;
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
        this.invalidPasscode = 'Invalid Passcode';
      }
    );
  }

  public screen(action: 'Login' | 'SignUp'): void {
    this.phoneNumberPin = '';
    this.loginStage = action === 'Login' ? '' : 'signUp';
  }

  public filterSubregions() {
    const postalCode = this.selectedPostalCode;
    if (postalCode.length >= 2) {
      this.filteredSubregionList = this.commonService.subRegionLists.filter(subregion =>
        subregion.postalCode.includes(postalCode.slice(0, 2))
      );
    } else {
      this.filteredSubregionList = [];
    }
  }

  public skip() {
    this.modalRef.close();
  }
}
